import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70e1e3f6")

_pushScopeId("data-v-70e1e3f6")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_validate_edit_box = _resolveComponent("validate-edit-box")
  const _component_number_list_inquiry = _resolveComponent("number-list-inquiry")
  const _component_date_and_age_inquiry = _resolveComponent("date-and-age-inquiry")
  const _component_single_select_inquiry = _resolveComponent("single-select-inquiry")
  const _component_address_list_inquiry = _resolveComponent("address-list-inquiry")
  const _component_pref_inquiry = _resolveComponent("pref-inquiry")

  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("h3", null, _toDisplayString(_ctx.pageTitle), 1),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.inquiries, (inquiry, i) => {
          return (_openBlock(), _createBlock(_Fragment, {
            key: `inquiry-${inquiry.key}`
          }, [
            (['string', 'number', 'city', 'email'].includes(inquiry.valueType))
              ? (_openBlock(), _createBlock(_component_validate_edit_box, {
                  key: 0,
                  class: "vue-content-edit-box",
                  title: inquiry.title,
                  placeholder: inquiry.placeholder,
                  required: inquiry.required,
                  validation: _ctx.submitted ? _ctx.validationErrors[_ctx.page][i] : undefined,
                  modelValue: _ctx.values[_ctx.page][i],
                  "onUpdate:modelValue": ($event: any) => (_ctx.values[_ctx.page][i] = $event)
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(inquiry.title), 1)
                  ]),
                  _: 2
                }, 1032, ["title", "placeholder", "required", "validation", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (inquiry.valueType === 'numberArray')
              ? (_openBlock(), _createBlock(_component_number_list_inquiry, {
                  key: 1,
                  title: inquiry.title,
                  placeholder: inquiry.placeholder,
                  "key-value": inquiry.key,
                  required: inquiry.required,
                  validation: _ctx.submitted ? _ctx.validationErrors[_ctx.page][i] : undefined,
                  modelValue: _ctx.values[_ctx.page][i],
                  "onUpdate:modelValue": ($event: any) => (_ctx.values[_ctx.page][i] = $event)
                }, null, 8, ["title", "placeholder", "key-value", "required", "validation", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (inquiry.valueType === 'dateAndAge')
              ? (_openBlock(), _createBlock(_component_date_and_age_inquiry, {
                  key: 2,
                  title: inquiry.title,
                  "key-value": inquiry.key,
                  required: inquiry.required,
                  modelValue: _ctx.values[_ctx.page][i],
                  "onUpdate:modelValue": ($event: any) => (_ctx.values[_ctx.page][i] = $event)
                }, null, 8, ["title", "key-value", "required", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (inquiry.valueType === 'radio')
              ? (_openBlock(), _createBlock(_component_single_select_inquiry, {
                  key: 3,
                  title: inquiry.title,
                  "group-id": inquiry.key,
                  radios: inquiry.options,
                  required: inquiry.required,
                  validation: _ctx.submitted ? _ctx.validationErrors[_ctx.page][i] : undefined,
                  modelValue: _ctx.values[_ctx.page][i],
                  "onUpdate:modelValue": ($event: any) => (_ctx.values[_ctx.page][i] = $event)
                }, null, 8, ["title", "group-id", "radios", "required", "validation", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (inquiry.valueType === 'zipCode')
              ? (_openBlock(), _createBlock(_component_validate_edit_box, {
                  key: 4,
                  class: "vue-content-edit-box",
                  title: inquiry.title,
                  placeholder: inquiry.placeholder,
                  required: inquiry.required,
                  validation: _ctx.submitted ? _ctx.validationErrors[_ctx.page][i] : undefined,
                  modelValue: _ctx.values[_ctx.page][i],
                  "onUpdate:modelValue": ($event: any) => (_ctx.values[_ctx.page][i] = $event)
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(inquiry.title), 1)
                  ]),
                  _: 2
                }, 1032, ["title", "placeholder", "required", "validation", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (inquiry.valueType === 'addressSelector')
              ? (_openBlock(), _createBlock(_component_address_list_inquiry, {
                  key: 5,
                  "key-value": inquiry.key,
                  "zip-code": _ctx.zipCode,
                  "set-pref": _ctx.setPref,
                  "set-city": _ctx.setCity,
                  "set-address": _ctx.setAddress,
                  next: _ctx.next,
                  required: inquiry.required,
                  validation: _ctx.submitted ? _ctx.validationErrors[_ctx.page][i] : undefined,
                  modelValue: _ctx.values[_ctx.page][i],
                  "onUpdate:modelValue": ($event: any) => (_ctx.values[_ctx.page][i] = $event)
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(inquiry.title), 1)
                  ]),
                  _: 2
                }, 1032, ["key-value", "zip-code", "set-pref", "set-city", "set-address", "next", "required", "validation", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true),
            (inquiry.valueType === 'pref')
              ? (_openBlock(), _createBlock(_component_pref_inquiry, {
                  key: 6,
                  title: inquiry.title,
                  required: inquiry.required,
                  validation: _ctx.submitted ? _ctx.validationErrors[_ctx.page][i] : undefined,
                  modelValue: _ctx.values[_ctx.page][i],
                  "onUpdate:modelValue": ($event: any) => (_ctx.values[_ctx.page][i] = $event)
                }, null, 8, ["title", "required", "validation", "modelValue", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
})